import React from "react";

interface FormAdresseProps {
  register: any;
  handleAddressChange: () => void;
}

const FormAdresse = ({ register, handleAddressChange }: FormAdresseProps) => {
  return (
    <>
      <hr />
      <div className="grid grid-cols-6 gap-3">
        <div className="col-span-3 sm:col-span-3">
          <label
            htmlFor="nom_adresse"
            className="block text-sm font-bold leading-6 text-gray-900"
          >
            Nom *
          </label>
          <input
            type="text"
            name="nom_adresse"
            id="nom_adresse"
            placeholder="Saisir nom"
            className=" my-3 border border-gray-300 text-gray-900 font-semibold text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
            {...register(`adresse.nom_adresse`)}
          />
        </div>
        <div className="col-span-3 sm:col-span-3">
          <label
            htmlFor="rue"
            className="block text-sm font-bold leading-6 text-gray-900"
          >
            Rue 1
          </label>

          <input
            type="text"
            name="rue"
            id="rue"
            placeholder="Saisir rue 1"
            className=" my-3 border border-gray-300 text-gray-900 font-semibold text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
            {...register(`adresse.rue`)}
          />
        </div>
        <div className="col-span-3 sm:col-span-3">
          <label
            htmlFor="rue2"
            className="block text-sm font-bold leading-6 text-gray-900"
          >
            Rue 2
          </label>
          <input
            type="text"
            name="rue2"
            id="rue2"
            placeholder="Saisir rue 2"
            className=" my-3 border border-gray-300 text-gray-900 font-semibold text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
            {...register(`adresse.rue2`)}
          />
        </div>

        <div className="col-span-3 sm:col-span-3">
          <label
            htmlFor="code_postal"
            className="block text-sm font-bold leading-6 text-gray-900"
          >
            Code postal *
          </label>

          <input
            type="text"
            name="code_postal"
            id="code_postal"
            placeholder="Saisir le code postal"
            className=" my-3 border border-gray-300 text-gray-900 font-semibold text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
            {...register(`adresse.code_postal`)}
          />
        </div>
        <div className="col-span-3 sm:col-span-3">
          <label
            htmlFor="ville"
            className="block text-sm font-bold leading-6 text-gray-900"
          >
            Ville *
          </label>

          <input
            type="text"
            name="ville"
            id="ville"
            placeholder="Saisir la ville"
            className=" my-3 border border-gray-300 text-gray-900 font-semibold text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
            {...register(`adresse.ville`)}
          />
        </div>
        <div className="col-span-3 sm:col-span-3">
          <label
            htmlFor="pays"
            className="block text-sm font-bold leading-6 text-gray-900"
          >
            Pays *
          </label>
          <input
            type="text"
            name="pays"
            id="pays"
            placeholder="Saisir le pays"
            className=" my-3 border border-gray-300 text-gray-900  font-semibold text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
            {...register(`adresse.pays`)}
          />
        </div>
      </div>
      <div className="flex justify-end">
        <button
          type="button"
          onClick={() => {
            handleAddressChange();
          }}
          className="text-white disabled:opacity-50  bg-gexpertise-200 hover:bg-gexpertise-100 font-medium rounded-lg text-sm px-3 py-2  text-center "
        >
          Ajouter adresse
        </button>
      </div>
    </>
  );
};

export default FormAdresse;
